// extracted by mini-css-extract-plugin
module.exports = {"colorBlack":"#000000"};